const pk9Header = document.querySelector('.header');
const pk9Hero = document.querySelector('[data-obsidian-hero]');
const pk9Product = document.querySelector('[data-obsidian-product]');

const updateHeader = () => {
  if (!pk9Header) return;
  pk9Header.toggleAttribute('data-scrolled', window.scrollY > 24);
};

updateHeader();
window.addEventListener('scroll', updateHeader, { passive: true });

if (pk9Hero && pk9Product && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  pk9Hero.addEventListener('pointermove', (event) => {
    const bounds = pk9Hero.getBoundingClientRect();
    const x = (event.clientX - bounds.left) / bounds.width - .5;
    const y = (event.clientY - bounds.top) / bounds.height - .5;
    pk9Product.style.setProperty('--pk9-product-x', `${x * 12}px`);
    pk9Product.style.setProperty('--pk9-product-y', `${y * 8}px`);
  });

  pk9Hero.addEventListener('pointerleave', () => {
    pk9Product.style.setProperty('--pk9-product-x', '0px');
    pk9Product.style.setProperty('--pk9-product-y', '0px');
  });
}
